import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { inviteOutlinedButtonSx } from "./inviteTypography";

export const InviteRevalidatingAction: React.FC = () => (
  <CircularProgress size={32} sx={{ mx: "auto" }} />
);

export const InviteFatalAction: React.FC<{
  onRetry?: () => void;
  showRetry?: boolean;
}> = ({ onRetry, showRetry = true }) => {
  if (!showRetry || !onRetry) return null;
  return (
    <Button
      variant="outlined"
      onClick={onRetry}
      fullWidth
      sx={(theme) => inviteOutlinedButtonSx(theme)}
    >
      Reintentar
    </Button>
  );
};
